module.exports = __webpack_public_path__ + "static/media/traffic-event.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/traffic-event.svg
// module id = 777
// module chunks = 0